import { environmentHttpClient } from "../httpClient";

export type SaveDetectedTimeZoneModel = {
	detectedTimeZone: string;
	timeZoneToPersist: OptionalModel<string>;
};

export async function setDetectedTimeZone(
	model: SaveDetectedTimeZoneModel,
	signal?: AbortSignal
): Promise<void> {
	return await environmentHttpClient.post<void>(
		"UserTimeZone/Detected",
		model,
		{
			signal
		}
	);
}